import { Component } from '@angular/core';
import {MatCardModule} from '@angular/material/card';

import { EtichettaIndex } from './interfaces/etichetta-index';
import { RouterModule } from '@angular/router';
import { FooterComponent } from "../../footer/footer.component";

@Component({
    selector: 'app-main-index',
    imports: [MatCardModule, RouterModule, FooterComponent],
    templateUrl: './main-index.component.html',
    styleUrl: './main-index.component.scss'
})
export class MainIndexComponent {
  // listaEtichette : EtichettaIndex[] = [
  //   {
  //     id: 1,
  //     titolo: 'Anagrafica',
  //     sotto_titolo: 'Anagrafica unificata per clienti, fornitori, prospect ed utenti.'
  //   },
  //   {
  //     id: 2,
  //     titolo: 'Calendario',
  //     sotto_titolo: 'Gestisci i tuoi appuntamenti, i lavori da svolgere e le risorse a disposizione della tua azienda.'
  //   }
  // ]
}
